
 /**
    2-A
    2-14
*/

import data_control from "../../../../../../engines/libs/data_control";
import { GoldFlowerKind } from "./GoldFlowerKind";

/** 牌型数据区间 */
const CardTypeArea = [
    2, 14
]
export class GoldFlowerDataManage {

    /**
     * 根据牌型生成牌数据
     * @param type 
     * @returns 
     */
    static generateCardType(
        type: number
    ): GoldFlowerKind.CardTypeData {
        let TYPE = GoldFlowerKind.CardType;
        switch(type) {
            case TYPE.YI_ZHANG: {
                return this.generateYiZhang();
            }
            case TYPE.YI_DUI: {
                return this.generateYiDui();
            }
            case TYPE.SHUN_ZI: {
                return this.generateShunZi();
            }
            case TYPE.SAN_TIAO: {
                return this.generateSanTiao();
            }
        }
    }

    /**
     * 生成参照区的牌
     * @param type 
     * @param excludeArr 
     * @returns 
     */
    static generateCardTypeRefer(
        type: number
        , excludeArr: number[][]
    ) {
        for (let o of excludeArr) {
            o.sort((a,b)=>a-b);
        }
        while(true) {
            let cardData = this.generateCardType(type);
            cardData.card.sort((a,b)=>a-b);

            let bSame = false;
            for (let o of excludeArr) {
                bSame = true;
                for (let i = 0; i < o.length; i++) {
                    if (cardData.card[i] != o[i]) {
                        bSame = false;
                        break;
                    }
                }
            }
            if (!bSame) {
                return cardData;
            }
        }
    }

    /**
     * 生成牌组合区的牌
     * @param type 
     * @param oCardData 
     * @param oCardType 
     * @param bWin 
     * @returns 
     */
    static generateCardTypeCom(
        type: number
        , oCardData: number[]
        , oCardType: number
        , bWin: boolean
    ) {
        while(true) {
            let retCardData = this.generateCardType(type);
            if (!retCardData) {
                console.error('数据为null type = ' + type);
            }
            retCardData.card.sort((a,b)=>b-a);

            let bMax = this.compareCard(oCardData, oCardType, retCardData.card, type);
            if (bWin) {
                if (!bMax) {
                    return retCardData;
                }
            } else {
                if (bMax) {
                    return retCardData;
                }
            }
        }
    }

    /**
     * 比较牌大小，大于为true，小于等于为false
     * @param card1 
     * @param card1Type 
     * @param card2 
     * @param card2Type 
     * @returns 
     */
    static compareCard(
        card1: number[],
        card1Type: number,
        card2: number[],
        card2Type: number,
    ) {
        if (card1Type != card2Type) {
            return card1Type > card2Type;
        }

        if (card1Type == GoldFlowerKind.CardType.YI_DUI) {
            let card1Dui = this.getDuiCard(card1);
            let card2Dui = this.getDuiCard(card2);
            if (card1Dui.dui != card2Dui.dui) {
                return card1Dui.dui > card2Dui.dui;
            }
            return card1Dui.dan > card2Dui.dan;
        }

        for (let i = 0; i < card1.length; i++) {
            if (card1[i] == card2[i]) {
                continue;
            }
            return card1[i] > card2[i];
        }
        return false;
    }

    static getDuiCard(card: number[]) {
        let dC: number = null;
        for (let i = 0; i < card.length; i++) {
            for (let j = 0; j < card.length; j++) {
                if (i==j) {
                    continue;
                }

                if (card[i] == card[j]) {
                    dC = card[i];
                }
            }    
        }

        if (dC != null) {
            for (let i = 0; i < card.length; i++) {
                let c = card[i];
                if (dC != c) {
                    return {
                        dui: dC
                        , dan: c
                    };
                }
            }
        }
        return null;
    }

    /**
     * 是否是顺子
     * @param card 
     * @returns 
     */
    static isCardShunZi(card: number[]) {
        card.sort((a,b)=> b-a);
        for (let i = 0; i < card.length-1; i++) {
            if ((card[i]-card[i+1]) == 1) {
                continue;
            }
            return false;
        }
        return true;
    }

    /**
     * 是否是牌型的最大最小值
     * @param type 
     * @param cardData 
     * @returns 
     */
    static isCardTypeMaxMinValue(type: number, cardData: number[], bMax: boolean) {
        let TYPE = GoldFlowerKind.CardType;
        let cardMin: number[] = [];
        switch(type) {
            case TYPE.YI_ZHANG: {
                if (bMax) {
                    cardMin = [14,13,11];
                } else {
                    cardMin = [5,3,2];
                }
            }
            break;
            case TYPE.YI_DUI: {
                if (bMax) {
                    cardMin = [14,14,13];
                } else {
                    cardMin = [3,2,2];
                }
            }
            break;
            case TYPE.SHUN_ZI: {
                if (bMax) {
                    cardMin = [14,13,12];
                } else {
                    cardMin = [4,3,2];
                }
            }
            break;
            case TYPE.SAN_TIAO: {
                if (bMax) {
                    cardMin = [14,14,14];
                } else {
                    cardMin = [2,2,2];
                }
            }
            break;
        }
        for (let i = 0; i < cardData.length; i++) {
            if (cardMin[i] != cardData[i]) {
                return false;
            }
        }
        return true;
    }

    /** 单张 */
    static generateYiZhang(): GoldFlowerKind.CardTypeData {
        let cardTypeData = new GoldFlowerKind.CardTypeData();
        let count = GoldFlowerKind.GeneralValue.CardCount;

        while(true) {
            cardTypeData.card = [];
            for (let i = 0; i < count; i++) {
                let card = data_control.randomNumInt(CardTypeArea[0], CardTypeArea[1]);
                if (cardTypeData.card.includes(card)) {
                    i--;
                    continue;
                }
                cardTypeData.card.push(card);
            }

            if (!this.isCardShunZi(cardTypeData.card)) {
                break;
            } 
        }
        
        return cardTypeData;
    }

    /** 一对 */
    static generateYiDui(): GoldFlowerKind.CardTypeData {
        let cardTypeData = new GoldFlowerKind.CardTypeData();
        let count = GoldFlowerKind.GeneralValue.CardCount;

        for (let i = 0; i < count-1; i++) {
            let card = data_control.randomNumInt(CardTypeArea[0], CardTypeArea[1]);
            if (cardTypeData.card.includes(card)) {
                i--;
                continue;
            }
            if (i==0) {
                cardTypeData.card.push(card, card);
            } else {
                cardTypeData.card.push(card);
            }
        }
        return cardTypeData;
    }

    /** 顺子 */
    static generateShunZi(): GoldFlowerKind.CardTypeData {
        let cardTypeData = new GoldFlowerKind.CardTypeData();
        let count = GoldFlowerKind.GeneralValue.CardCount;

        let cardStart = data_control.randomNumInt(CardTypeArea[0], CardTypeArea[1]-count+1);
        cardTypeData.card.push(cardStart, cardStart+1, cardStart+2);
        return cardTypeData;
    }

    /** 3条 */
    static generateSanTiao(): GoldFlowerKind.CardTypeData {
        let cardTypeData = new GoldFlowerKind.CardTypeData();
        let cardStart = data_control.randomNumInt(CardTypeArea[0], CardTypeArea[1]);
        cardTypeData.card.push(cardStart, cardStart, cardStart);
        return cardTypeData;
    }
}